import { buildDispatchable } from '../../actions/_action-utilities';
import { connect } from 'react-redux';
import SSOLogin from './sso-login';
import { loginViaSSO, exchangeTokenSso } from '../../actions/login.action';
const mapStateToProps = (props)=>{
    const { login } = props;
    return {
        loading: login.loading
    };
};
const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        loginViaSSO: async (item)=>{
            runDispatchable(()=>{
                return dispatch(loginViaSSO(item));
            });
        },
        exchangeTokenSso: async (idToken)=>{
            runDispatchable(()=>{
                return dispatch(exchangeTokenSso(idToken));
            });
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SSOLogin);
